import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const getFeatureDetails = createAsyncThunk('getFeatureDetails', async (object, { rejectWithValue }) => {
  const response = await request('/api/v1/features/get-all-features', { method: 'GET' , auth: true});
  console.log('response :', response);

  if (response?.data) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});

export const getFeaturesListByTenant = createAsyncThunk('getFeaturesListByTenant', async (object, { rejectWithValue }) => {
  const response = await request('/api/v1/features/get-features-by-tenant', { method: 'GET', params: object.id , auth: true});

  if (response?.data) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});
